// removed by extract-text-webpack-plugin
module.exports = {"carousel":"_3g9npIos","single":"_3i7leXty","dots":"_2inrpDpV","prev":"FUZrGS4z","next":"_2M366iRn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/Carousel.pcss
// module id = 777
// module chunks = 0